import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { EVENT_START_ISO, EVENT_END_ISO, DATE_DEBUT } from "../config";

const computeState = () => {
  const now = new Date();
  const start = new Date(EVENT_START_ISO);
  const end = new Date(EVENT_END_ISO);

  if (now < start) {
    const days = Math.ceil((start - now) / 86400000);
    if (days <= 1) return { label: `Ça commence demain · ${DATE_DEBUT}`, live: false };
    return { label: `Début le ${DATE_DEBUT} · dans ${days} jours`, live: false };
  }
  if (now <= end) return { label: "L'expérience est en cours", live: true };
  return { label: "Prochaine session bientôt annoncée", live: false };
};

// Rappel élégant auto-actualisé, sans fausse urgence (mise à jour toutes les minutes).
export default function CountdownReminder() {
  const [state, setState] = useState(computeState);

  useEffect(() => {
    const id = setInterval(() => setState(computeState()), 60000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="countdown" data-testid="countdown-reminder">
      <span className={`countdown__dot ${state.live ? "countdown__dot--live" : ""}`} />
      <CalendarDays size={15} strokeWidth={1.7} className="countdown__icon" />
      <span data-testid="countdown-label">{state.label}</span>
    </div>
  );
}
